/* eslint-disable @typescript-eslint/naming-convention */
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { SmartForm } from 'components';
import { saveSetting, getSetting } from 'rdx/config';
import { valueToInteger } from 'utils';

import productSettingsSchema from './productSettingsSchema';
import './productsSettings.scss';

function ProductSettings() {
  const settingsFormRef = React.useRef(null);
  const dispatch = useDispatch();
  const [configState, setConfigState] = useState({});

  const touchpos_search_product_code_from_middle = useSelector(
    getSetting('touchpos_search_product_code_from_middle'),
  );
  const touchpos_sort_products_by_code = useSelector(
    getSetting('touchpos_sort_products_by_code'),
  );
  const touchpos_disable_product_row_auto_open = useSelector(
    getSetting('touchpos_disable_product_row_auto_open'),
  );
  const touchpos_disable_related_products_popup = useSelector(
    getSetting('touchpos_disable_related_products_popup'),
  );
  const touchpos_disable_zero_price_auto_open = useSelector(
    getSetting('touchpos_disable_zero_price_auto_open'),
  );
  const touchpos_out_of_stock_warning = useSelector(
    getSetting('touchpos_out_of_stock_warning'),
  );
  const touchpos_exact_code_match_adds_product_to_ticket = useSelector(
    getSetting('touchpos_exact_code_match_adds_product_to_ticket'),
  );
  const touchpos_disable_product_image_display = useSelector(
    getSetting('touchpos_disable_product_image_display'),
  );
  const touchpos_autoclose_line_after_discount_selected = useSelector(
    getSetting('touchpos_autoclose_line_after_discount_selected'),
  );
  useEffect(() => {
    setConfigState({
      touchpos_search_product_code_from_middle,
      touchpos_sort_products_by_code,
      touchpos_disable_product_row_auto_open,
      touchpos_disable_related_products_popup,
      touchpos_disable_zero_price_auto_open,
      touchpos_out_of_stock_warning,
      touchpos_exact_code_match_adds_product_to_ticket,
      touchpos_disable_product_image_display,
      touchpos_autoclose_line_after_discount_selected,
    });
  }, [
    touchpos_search_product_code_from_middle,
    touchpos_sort_products_by_code,
    touchpos_disable_product_row_auto_open,
    touchpos_disable_related_products_popup,
    touchpos_disable_zero_price_auto_open,
    touchpos_out_of_stock_warning,
    touchpos_exact_code_match_adds_product_to_ticket,
    touchpos_disable_product_image_display,
    touchpos_autoclose_line_after_discount_selected,
  ]);

  const submitSetting = () => {
    const { values: currentValues } = settingsFormRef.current;

    Object.entries(currentValues).forEach(([key, value]) => {
      const payload = {};

      payload.parameterName = key;
      payload.parameterValue =
        typeof value === 'boolean' ? valueToInteger(value) : value;

      if (payload.parameterValue !== configState[key])
        dispatch(saveSetting(payload));
    });
  };
  return (
    <SmartForm
      grid
      ref={settingsFormRef}
      state={configState}
      fields={productSettingsSchema}
      autosave
      handleSubmit={submitSetting}
      className="product-form"
    />
  );
}

export default ProductSettings;
